/* eslint-disable react/prop-types */ // TODO: add props
import PropTypes from 'prop-types';
import { Component } from 'react';
import { FormControl } from 'react-bootstrap';
import pluralize from 'pluralize';

class MarkingResponse extends Component {
  static propTypes = {
    label: PropTypes.string,
    marksAvailable: PropTypes.number,
    response: PropTypes.object,
  };

  constructor(props) {
    super(props);
    const answer = props.response.get('answer');
    // Default to empty string, except if answer is zero
    const value = answer === 0 ? 0 : answer || '';
    this.state = { value };
  }

  handleChange = (e) => {
    const value = e.target.value === '' ? '' : parseInt(e.target.value, 10);
    if (
      value === '' ||
      (!isNaN(value) && value >= 0 && value <= this.props.marksAvailable)
    ) {
      this.setState({
        value: `${value}`,
      });
      this.props.onChange(e);
    }
  };

  render() {
    const { label, marksAvailable, onKeyUp } = this.props;
    return (
      <div className="response form-group">
        {label ? <label>{label}</label> : null}
        <div className="input-group">
          <FormControl
            type="text"
            value={this.state.value}
            onChange={this.handleChange}
            onKeyUp={onKeyUp}
          />
          <div className="input-group-addon">
            /{pluralize('mark', marksAvailable, true)}
          </div>
        </div>
      </div>
    );
  }
}

export default MarkingResponse;
